import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DUMMYRULES, EngineRule, IEngineRuleList } from '../models/engine-rule';
import { BaseRestService } from './base-rest.service';
import { SubjectTypeService } from './subject-type.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable()
export class RulesEngineService extends BaseRestService<EngineRule, IEngineRuleList> implements OnDestroy{

dummyData: EngineRule[] = DUMMYRULES;

    constructor(http: HttpClient, private subjectTypeService: SubjectTypeService, protected router: Router) {
    // need a super call but it doesn't do anything
    super(RulesEngineService, http, 'api/categories', 'category', router);

    // enable caching
    this.cacheEnabled = false;
  }

  ngOnDestroy(): void { }

  getAll() {
//    this.subjectTypeService.getAllData().pipe(take(1)).subscribe((_) => {
//      super.getAll();
//    });
  this.onChanged.next(this.dummyData);
  }

  save(entity: EngineRule, successMessage?: string) {
    this.dummyData.push(entity);
    this.onChanged.next(this.dummyData);
  }
  /*
  getCategoryByName(category: string): Observable<EngineRule>{
    return this.getAllData().pipe(take(1), map((categories) => {
      return categories.find((x) => x.description.toLowerCase() === category.toLowerCase());
    }));
  }

  getCategoriesBySubjectType(subjectTypeId: number): Observable<EngineRule[]>{
    return this.getAllData().pipe(take(1), map((categories) => {
      if (subjectTypeId){
        return categories.filter((x) => (x.subjectTypeId === subjectTypeId) && (!x.hideRecord));
      }
      else{
        return categories.filter((x) => (!x.hideRecord));
      }
    }));
  }

  hydrate(item: EngineRule): Observable<EngineRule> {
    if ((!item.subjectType) || (item.subjectType.id !== item.subjectTypeId)){
      return this.subjectTypeService.getById(item.subjectTypeId).pipe(map((subjectType) => {
        item.subjectType = new SubjectType(subjectType);
        return item;
      }));
    }
    else{
      return of(item);
    }
  }
  */
}
